"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedMode = void 0;
var EmbedMode;
(function (EmbedMode) {
    EmbedMode[EmbedMode["Seamless"] = 0] = "Seamless";
    EmbedMode[EmbedMode["IFrame"] = 1] = "IFrame";
})(EmbedMode = exports.EmbedMode || (exports.EmbedMode = {}));
